/******************************************************************************
 *** BgtMbsdsAtrzExpndList ** 운영비 결재상신 * 지출결의서 리스트 조회
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import DialogTitleBar from "../../common/DialogTitleBar";
import Button from "@/js/common/ui/Button";
import BgtMbsdsExpndViewDialog from "./dialog/BgtMbsdsExpndViewDialog";

interface Props {
    ognzCd    : string;  // 조직코드(지부)
    acntgYear : string;  // 회계연도
    searchKywd: string;  // 검색어(적요)
    callTime  : Date;
    setProcBgtSbjctSeCd: Function; // 구분코드
    expenseCheckArr: any[]     // 체크된 지출결의서 List
    setExpenseCheckArr: React.Dispatch<React.SetStateAction<any[]>>;
    setAtrzTitleModalOpen: Function;
    atrzProcessing: boolean; // 결재상신 처리 후 완료 전까지 결재상신 버튼 비활성화
}
const BgtMbsdsAtrzExpndList = ( {ognzCd, acntgYear, searchKywd, callTime, setProcBgtSbjctSeCd, expenseCheckArr, setExpenseCheckArr, setAtrzTitleModalOpen, atrzProcessing}: Props ) => {
    const [expenseDataArr, setExpenseDataArr ] = React.useState<any[]>([]);  // 지출결의서 목록
    const [sumExpenseAmt , setSumExpenseAmt  ] = React.useState<string>(""); // 지출 내역 합계

    const [mbsdsExpndModalOpen, setMbsdsExpndModalOpen] = React.useState<boolean>(false); // 지출결의서 상세정보 모달
    const [mbsdsExpndDocId    , setMbsdsExpndDocId] = React.useState<string>(""); // 지출결의서 문서 ID

    // GridTable 컬럼 정의
    const expenseFldInfs: fldInfsProps[] = [
        { type: "date", fldNm: "implDt"             , width: 120, headAlign: "center", dataAlign: "center", label: "지출일자" },
        { type: "text", fldNm: "expndRsdocSeNm"     , width:  60, headAlign: "center", dataAlign: "center", label: "구분"     },
        { type: "text", fldNm: "bgtSbjct1stNm"      , width: 100, headAlign: "center", dataAlign: "center", label: "관"       },
        { type: "text", fldNm: "bgtSbjct2stNm"      , width: 100, headAlign: "center", dataAlign: "center", label: "항"       },
        { type: "text", fldNm: "bgtSbjct3stNm"      , width: 100, headAlign: "center", dataAlign: "center", label: "목"       },
        { type: "text", fldNm: "abstrCn"            , width: 210, headAlign: "center", dataAlign: "left"  , label: "적요"     },
        { type: "comma", fldNm: "implAmt"           , width: 120, headAlign: "center", dataAlign: "right" , label: "금액"     },
        { type: "text", fldNm: "atrzSttsNm"         , width:  70, headAlign: "center", dataAlign: "center", label: "진행상태" },
        { type: "text", fldNm: "crtDt"              , width: 120, headAlign: "center", dataAlign: "center", label: "작성일시" },
        { type: "text", fldNm: "expndRsdocNo"       , width: 130, headAlign: "center", dataAlign: "left"  , label: "문서번호" },
    ];

    // 총괄조합비 지출결의서 목록 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/mbsds/atrz/select-atrz-rtso-expnd-list.do", // 결재상신 지출결의서 목록 조회
            methodType: "post",
            paramType: "json",
            paramData: {
                orgCd     : ognzCd    , // 조직코드
                acntgYear : acntgYear , // 회계연도
            },
            onSuccessFn: (res: any) => {
                setExpenseDataArr(res.result.list);
                setSumExpenseAmt(res.result.listSum.sumImplAmt);
                AppContext.hideSpinner();
            },
        });
    }, [callTime, ognzCd, acntgYear]);

    React.useEffect(() => {
        let sum = 0;
        for (const row of Util.filterFieldData(expenseDataArr, expenseFldInfs, "abstrCn", searchKywd)) {
            sum += Number(row.implAmt) || 0;
        }
        setSumExpenseAmt(Util.comma(String(sum)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expenseDataArr, searchKywd]);

    // 결재상신
    function goApproval() {
        if (expenseCheckArr.length === 0) {
            AppContext.openAlert({ title: "지출결의서 선택 확인", msg: "결재상신할 지출결의서를 선택하세요.", icon: "warning" }); return;
        }
        setProcBgtSbjctSeCd("02"); // 구분코드(지출[02])
        setAtrzTitleModalOpen(true); // 결재 제목 입력 모달 오픈
    }

    return (
        <div className="bd1d9d9d9 bdrd6 bgcWhite p15">
            <div className="dpFlx aiC jcSb mb10 h44">
                <span className="fm-b fs16 fc007bff ls1 fw700">지출 결의서</span>
                {/* 결재상신 버튼 */}
                <div className="dpFlx">
                    <Button buttonName="결재 상신"
                        width={140} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                        variant="styCompleteBtn" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={() => goApproval()}
                        disabled={atrzProcessing}
                    />
                </div>
            </div>

            {/* 그리드 */}
            <GridTable
                tableInfo={{
                    tableHeadVsb: true,
                    styleType: AdminGridStyle,
                    fldInfs: expenseFldInfs,
                    ordFld: { name: "implDt", direction: "desc" },
                    dataArr: Util.filterFieldData(expenseDataArr, expenseFldInfs, "abstrCn", searchKywd),
                    maxRowNums: [50],
                    theadTrHeight: 40,
                    tbodyTrHeight: 35,
                    paginateClass: "pt10",
                    paginateStyle: {
                        buttonOnColor: AppContext.boardThemeColor,
                        buttonWidth: 22,
                        buttonHeight: 24,
                        buttonMarginLeft: 1,
                        buttonMarginRight: 1,
                        fontSize: 13,
                        color: "#666666",
                        letterSpacing: -0.8,
                        fontFamily: "Pretendard-Regular",
                        borderRadius: 3,
                    },
                    footerVsb: false,
                    checkedHookParam: {
                        checkDataArr: expenseCheckArr,
                        setCheckDataArr: setExpenseCheckArr,
                    },
                    rowClickFunc: (item: any) => {  // row click
                        setMbsdsExpndDocId(item.mbsdsExpndDocId);
                        setMbsdsExpndModalOpen(true);
                    },
                }}
            />

            {/* 합계 라인 (그리드 아래 별도 테이블) */}
            <div>
                <table className="w100p bgcDCDCDC">
                    <colgroup>
                        <col style={{width: "35px" }}></col>
                        <col style={{width: "120px"}}></col>
                        <col style={{width: "60px"}}></col>
                        <col style={{width: "100px"}}></col>
                        <col style={{width: "100px"}}></col>
                        <col style={{width: "100px"}}></col>
                        <col style={{width: "210px"}}></col>
                        <col style={{width: "120px"}}></col>
                        <col style={{width: " 70px"}}></col>
                        <col style={{width: "120px"}}></col>
                        <col style={{width: "130px"}}></col>
                    </colgroup>
                    <tbody>
                        <tr style={{height: "35px"}}>
                            <td></td>
                            <td colSpan={2}></td>
                            <td colSpan={3} style={{textAlign: "center"}}><span className="fm-c fs15 ls06 fc2c3e50">합계</span></td>
                            <td colSpan={2} style={{textAlign: "right", paddingRight: "5px"}}>
                                <span className="fs15 ls075">{Util.comma(sumExpenseAmt)}</span>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>                
            </div>

            {/* 지출결의서 상세정보 모달 */}
            <Modal modalOpen={mbsdsExpndModalOpen} dim={true} visible={true}
                titleEl={<DialogTitleBar title="지출결의서 상세내용" />}
                onCloseFunc={() => {
                    setMbsdsExpndDocId("");
                    setMbsdsExpndModalOpen(false);
                }}
            >
                <BgtMbsdsExpndViewDialog
                    mbsdsExpndDocId        = {mbsdsExpndDocId}     // 지출결의서 문서 ID
                    setMbsdsExpndModalOpen = {setMbsdsExpndModalOpen}
                />
            </Modal>
        </div>
    )
}

export default BgtMbsdsAtrzExpndList;